export default "__VITE_ASSET__CS5cyIvG__"